import {
  buildMatchMapLoad,
  createTurretsFromPlan,
  createSpawnersFromPlan
} from '../application/matchMapLoad.js';

/**
 * bootSandboxStructures — P3-03 factory-only structure/spawner boot for live client.
 */
export function bootSandboxStructures(mapId = 'test_map') {
  const plan = buildMatchMapLoad(mapId);
  const turrets = createTurretsFromPlan(plan);
  const spawners = createSpawnersFromPlan(plan, turrets);
  return {
    plan,
    turrets,
    blueTurret: turrets.find((t) => t.team === 'blue') || turrets[0] || null,
    redTurret: turrets.find((t) => t.team === 'red') || turrets[1] || null,
    blueSpawner: spawners.find((s) => s.team === 'blue') || spawners[0] || null,
    redSpawner: spawners.find((s) => s.team === 'red') || spawners[1] || null
  };
}
